import { makeStyles } from '@mui/styles'
import {
  FinanceCalculatorTheme,
  FcFinanceDisclaimerWidgetClasses,
} from '@dxp-module/themes'

const disclaimerStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceDisclaimerWidgetClasses
>(
  ({ typography, palette }) => ({
    container: {
      margin: '20px',
    },
    disclaimerText: {
      lineHeight: typography.pxToRem(17),
      color: palette.common.black,
      whiteSpace: 'pre-wrap',
    },
  }),
  { name: 'FC_FinanceDisclaimerWidget' }
)

export default disclaimerStyles
